export default function (object, callable) {
    return Object.fromEntries( Object.entries( object ).
            filter( ( [ key, value ] ) => callable( value ) ) );
}